import React, { useMemo, useState } from 'react';
import {
  Button, Card, Col, Form, Row,
} from 'react-bootstrap';
import { status as PS } from '../../../helpers/passport';

export default function ExpertDecisionCard({
  className, proj, onEdit, readOnly, cardTitle,
}) {
  const [recommendations, setRecommendations] = useState('');
  const [protocol, setProtocol] = useState('');

  useMemo(() => {
    setRecommendations(proj.expertGroupDecision);
    setProtocol(proj.expertGroupProtocol);
  }, [proj]);

  const handleRecommendationsChange = ({ target }) => {
    setRecommendations(target.value);
  };

  const handleProtocolChange = ({ target }) => {
    setProtocol(target.value);
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    await onEdit({ recommendations, protocol });
  };

  const parseIsApprovedText = () => {
    const statusesApproved = [PS.expertsApproved, PS.approved];
    const statusesDeclined = [PS.expertsDeclined];

    if (statusesApproved.includes(proj.status)) return 'Одобрено';
    if (statusesDeclined.includes(proj.status)) return 'Не одобрено';

    return '';
  };

  return (
    <Card className={className}>
      <Card.Header as={Card.Title} className="p-4">
        {cardTitle || 'Решение экспертной группы'}
      </Card.Header>
      <Card.Body className="p-4">
        { readOnly
                && (
                <>
                  <Row className="mb-4">
                    <Col md={6}>
                      <Card.Subtitle className="mb-2 text-muted">Решение</Card.Subtitle>
                      <Card.Text>{parseIsApprovedText()}</Card.Text>
                    </Col>
                    <Col md={6}>
                      <Card.Subtitle className="mb-2 text-muted">Реквизиты протокола</Card.Subtitle>
                      <Card.Text>{proj.expertGroupProtocol}</Card.Text>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <Card.Subtitle className="mb-2 text-muted">Рекомендации</Card.Subtitle>
                      <Card.Text style={{ whiteSpace: 'pre-wrap' }}>{proj.expertGroupDecision}</Card.Text>
                    </Col>
                  </Row>
                </>
                )}
        { !readOnly
                && (
                <>
                  <Row className="mb-4">
                    <Col md={6}>
                      <Card.Subtitle className="mb-2 text-muted">Решение</Card.Subtitle>
                      <Card.Text>{parseIsApprovedText()}</Card.Text>
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Form.Group as={Col} md="12">
                      <Form.Label>Рекомендации</Form.Label>
                      <Form.Control
                        value={recommendations}
                        onChange={handleRecommendationsChange}
                      />
                    </Form.Group>
                  </Row>

                  <Row className="mb-4">
                    <Form.Group as={Col} md="12">
                      <Form.Label>Реквизиты протокола</Form.Label>
                      <Form.Control
                        value={protocol}
                        onChange={handleProtocolChange}
                      />
                    </Form.Group>
                  </Row>
                  <Button as={Col} variant="outline-primary" onClick={handleEdit}>Сохранить рекомендации/реквизиты протокола</Button>
                </>
                )}
      </Card.Body>
    </Card>
  );
}
